{
  "home": {
    "menu": {
      "title": "Accueil"
    },
    "page": {
      "title": "Accueil"
    },
    "search": {
      "placeholder": "Rechercher"
    },
    "map": {
      "label": "Carte d'activité",
      "loading": "Chargement de la carte…",
      "error": "Impossible de charger les données de la carte.",
      "empty": "Aucune donnée pour cette période.",
      "emptyAssets": "Aucun actif pour cette période.",
      "emptyActivity": "Aucune activité pour cette période.",
      "emptyRoutines": "Aucune activité de routine pour cette période.",
      "emptyProducts": "Aucun produit pour cette période.",
      "noResults": "Aucun résultat pour cette recherche."
    },
    "activity": {
      "title": "Activité",
      "total": "{{count}} au total",
      "viewAll": "Voir tout",
      "solved": "Résolu",
      "pending": "En attente",
      "urgent": "Urgent",
      "error": "Impossible de charger les données d'activité",
      "empty": "Aucune activité pour cette période",
      "plot": "Tracer les activités sur la carte"
    },
    "cards": {
      "viewAll": "Voir tout",
      "error": "Impossible de charger les données"
    },
    "assets": {
      "title": "Actifs",
      "empty": "Aucun actif pour cette période",
      "plot": "Tracer les actifs sur la carte",
      "filterBy": "Filtrer la carte par {{status}}"
    },
    "routines": {
      "title": "Routines",
      "empty": "Aucune routine",
      "plot": "Tracer les emplacements des routines sur la carte",
      "filterBy": "Tracer {{name}} sur la carte"
    },
    "products": {
      "title": "Produits",
      "empty": "Aucun produit",
      "plot": "Tracer les produits sur la carte",
      "filterBy": "Tracer {{name}} sur la carte"
    },
    "campaigns": {
      "title": "Campagnes",
      "empty": "Aucune campagne"
    },
    "customers": {
      "title": "Clients",
      "empty": "Aucun client",
      "sample": "Données d'exemple",
      "active": "Actif",
      "pending": "En attente",
      "new": "Nouveau"
    },
    "plot": {
      "activity": "Affichage des activités",
      "asset": "Affichage des actifs",
      "routine": "Affichage des emplacements des routines",
      "product": "Affichage des produits"
    },
    "timeRange": {
      "label": "Plage de temps",
      "today": {
        "label": "Aujourd'hui",
        "a11y": "Aujourd'hui"
      },
      "7d": {
        "label": "7D",
        "a11y": "7 derniers jours"
      },
      "30d": {
        "label": "30D",
        "a11y": "30 derniers jours"
      },
      "90d": {
        "label": "90D",
        "a11y": "90 derniers jours"
      },
      "1y": {
        "label": "1Y",
        "a11y": "Dernière année"
      },
      "all": {
        "label": "Tout",
        "a11y": "Tout le temps"
      }
    }
  },
  "accountPage": {
    "header": {
      "accountTypes": "Types de compte",
      "newUsersSetup": "Les nouveaux utilisateurs seront ajoutés en tant que"
    },
    "types": {
      "general": "Général",
      "admin": "Administrateur",
      "restricted": "Restreint",
      "anonymous": "Anonyme"
    },
    "table": {
      "headers": {
        "accountType": "Type de compte",
        "accessActivity": "Accès à l'activité ?",
        "accessSettings": "Accès aux paramètres ?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Limité aux actifs et groupes partagés",
        "generalToSettingsNote": "Limité aux actifs et personnes"
      }
    },
    "info": {
      "header": "Types de compte expliqués",
      "admin": "Idéal pour les propriétaires de lieux de travail, les cadres supérieurs et les administrateurs de bureau.",
      "general": "Idéal pour le personnel et les employés à temps plein. (Notre recommandation par défaut.)",
      "restricted": "Idéal pour les visiteurs connus, les fournisseurs, les travailleurs à temps partiel et les entrepreneurs qui nécessitent un accès partiel ou limité.",
      "anonymous": "Pour les personnes qui ne se sont pas inscrites avec Gripp. Ils ne peuvent soumettre que des rapports, des notes ou des routines en fonction de ce qu'ils scannent."
    },
    "menu": {
      "accountPage": "Compte",
      "settingsPage": "Paramètres",
      "workspaceSettingsPage": "Paramètres de l'espace de travail"
    },
    "workplaceTitle": "Gestion et données du lieu de travail",
    "downloadData": "Télécharger les données",
    "dataExport": {
      "cancel": "Annuler",
      "title": "Exportation de données",
      "download": "Télécharger"
    }
  },
  "account": {
    "allWorkspaces": "Tous les espaces de travail",
    "create": {
      "button": "Ajouter un utilisateur",
      "form": {
        "email": "E-mail",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "role": "Rôle"
      },
      "validation": {
        "emailRequired": "L'e-mail est requis",
        "role": "Le rôle est requis",
        "validEmail": "Veuillez entrer un e-mail valide"
      }
    },
    "filter": {
      "apply": "Appliquer",
      "columnSelection": "Colonnes",
      "columns": {
        "createdAt": "Date d'adhésion",
        "createdDate": "Date d'adhésion",
        "createdTime": "Heure d'adhésion",
        "email": "E-mail",
        "groups": "Groupes",
        "groupNames": "Noms de Groupes",
        "assets": "Actifs",
        "jobTitle": "Titre du poste",
        "location": "Emplacement",
        "name": "Nom (requis)",
        "phone": "Numéro de téléphone",
        "roles": "Type de compte",
        "workspace": "Espace de travail"
      },
      "searchPlaceholder": "Rechercher un nom, un numéro ou un e-mail",
      "columnButton": "Colonnes",
      "groupsButton": "Groupes",
      "accountTypesButton": "Types de compte",
      "noAccountTypes": "Aucun type de compte",
      "groups": "Groupes",
      "accountTypes": "Types de compte",
      "default": "Par défaut",
      "viewResults": "Voir {{count}} résultats"
    },
    "groups": {
      "addPeopleTo": "Ajouter {{count}} personnes à :",
      "addPersonTo": "Ajouter 1 personne à :"
    },
    "list": {
      "accountType": "Type de compte",
      "added": "Date d'adhésion",
      "createdDate": "Date d'adhésion",
      "createdTime": "Heure d'adhésion",
      "email": "E-mail",
      "groups": "Groupes",
      "assets": "Actifs",
      "jobTitle": "Titre du poste",
      "location": "Emplacement",
      "name": "Nom",
      "phone": "Numéro de téléphone",
      "workspace": "Espace de travail"
    },
    "topBar": {
      "peopleSelected": "{{count}} personnes sélectionnées",
      "personSelected": "1 personne sélectionnée"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Oui",
        "secondaryButton": "Annuler",
        "title": "Êtes-vous sûr de vouloir supprimer {{accountName}} ?"
      }
    },
    "detail": {
      "removeAccount": "Supprimer le compte"
    }
  },
  "activity": {
    "filter": {
      "cancel": "Annuler",
      "groups": "Groupes",
      "activityOptions": "Options d'activité",
      "activityTypes": "Types d'activité",
      "options": "Options",
      "types": "Types",
      "notes": "Notes",
      "note": "Note",
      "pending": "En attente",
      "reset": "Réinitialiser",
      "routines": "Routines",
      "searchPlaceholder": "Rechercher des titres d'activité ou le nom de l'actif",
      "searchLabels": "Rechercher des étiquettes",
      "solved": "Résolu",
      "title": "Filtres",
      "labels": "Étiquettes",
      "urgent": "Urgent",
      "date": "Date",
      "all": "Tout",
      "day": "jour",
      "week": "semaine",
      "month": "mois",
      "today": "Aujourd'hui",
      "thisWeek": "7 derniers jours",
      "thisMonth": "30 derniers jours",
      "custom": "Personnalisé",
      "customDate": "Date personnalisée",
      "from": "De",
      "to": "À",
      "mentions": "Mentions",
      "scheduled": "Programmé",
      "default": "Par défaut",
      "notScheduled": "Non programmé",
      "pinned": "Épinglé",
      "everything": "Tout",
      "onlyMentions": "Seulement les mentions",
      "onlyPinned": "Seulement les épinglés",
      "onlyScheduled": "Seulement les programmés",
      "sort": "Trier",
      "viewResults": "Voir {{count}} résultats",
      "combinedGroups": "Filtrage combiné"
    },
    "search": {
      "title": "Rechercher",
      "search": "Rechercher",
      "recentSearches": "Recherches récentes"
    },
    "header": {
      "title": "Activité",
      "view": "Voir",
      "viewAll": "Tout voir"
    },
    "list": {
      "youAreMentioned": "Vous êtes mentionné."
    },
    "menu": {
      "title": "Activité",
      "titlePlural": "Activités"
    },
    "textEmpty": "Aucune activité",
    "topBar": {
      "results": "résultats"
    },
    "sort": {
      "mostRecent": "Dernière mise à jour",
      "reminderDate": "Date de rappel",
      "oldest": "Date de création"
    },
    "edit": {
      "tab": {
        "activity": "Activité",
        "routine": "Routine"
      }
    },
    "tapScan": "Tap “+” to scan assets or invitation codes.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "Rejoindre un espace de travail !",
        "description": "Vous n'êtes pas encore dans un espace de travail.\nScannez un code d'invitation pour rejoindre un\nespace de travail !"
      },
      "addActivity": {
        "title": "Ajouter une activité",
        "description": "Vous n'avez pas encore d'activité.\nAppuyez sur '+' pour ajouter un rapport ou une note sur votre actif et tenir votre équipe informée."
      },
      "addAsset": {
        "title": "Ajouter des actifs",
        "description": "Vous n'avez pas encore d'actifs.\nAppuyez sur '+' pour scanner et ajouter votre premier actif pour commencer."
      },
      "or": "ou",
      "newSub": "démarrer un nouvel abonnement",
      "here": "ici"
    }
  },
  "admin": {
    "menu": {
      "admin": "Personnes",
      "workspaces": "Espaces de travail"
    }
  },
  "alerts": {
    "addAnother": "Ajouter un autre",
    "create": {
      "alertName": "Nom de l'alerte",
      "asset(s)": "Actif(s)",
      "assetSearchPlaceholder": "Rechercher un nom d'actif",
      "assets": "Actifs",
      "doNotAlert": "<0>(Optionnel)</0><1>Ne pas alerter entre :</1>",
      "groupSearchPlaceholder": "Rechercher un nom de groupe",
      "groups": "Groupes",
      "promptRoutine": "<0>(Optionnel)</0><1>Sélectionner une routine</1><0>pour inviter avec cette alerte :</0>",
      "promptRoutinePlaceholder": "aucune routine sélectionnée",
      "title": "Créer une alerte",
      "what": "1. Choisir quoi :",
      "when": "3. Choisir quand :",
      "why": "2. Choisir pourquoi :"
    },
    "setAlert": "Ajouter une alerte",
    "setANewAlert": "Définir une nouvelle alerte",
    "createButton": "Créer nouveau",
    "createNewAlert": "Créer une nouvelle alerte",
    "createAlert": "Créer une alerte",
    "alert": "Alerte",
    "alerts": "Alertes",
    "deleteAlert": "Supprimer l'alerte",
    "nextAlert": "Prochaine alerte : ",
    "lastAlert": "Dernière alerte : ",
    "lastAlertNA": "N/A",
    "confirm": "Confirmer",
    "currently": "Actuellement : ",
    "abovePlaceholder": "au-dessus",
    "belowPlaceholder": "en dessous",
    "editAlert": "Modifier l'alerte",
    "intervalValue": "Valeur de l'intervalle",
    "newAlert": "Nouvelle alerte",
    "number": "Nombre",
    "minDropdownPlaceholder": "Quand c'est au-dessus de _____ ",
    "maxDropdownPlaceholder": "Quand c'est en dessous de _____ ",
    "setAlertLogic": "Définir la logique d'alerte",
    "setAlertLogicPlaceholder": "Sélectionner une logique d'alerte",
    "optionalSettings": "Paramètres optionnels",
    "customLabelTitle": "Personnaliser le titre de l'alerte",
    "blackoutDates": "Dates de black-out ?",
    "startDate": "Date de début",
    "starting": "Début",
    "day": "jour",
    "days": "jours",
    "togo": "restant",
    "completions": "complétions",
    "recorded": "enregistré",
    "elapsed": "écoulé",
    "OR": "OU",
    "or": "ou",
    "on": "sur",
    "skipped": "ignoré",
    "every": "chaque",
    "Every": "Chaque",
    "startingValue": "Valeur de départ",
    "startingValuePerAsset": "Valeur de départ par actif",
    "onDate": "À une date spécifique",
    "onDays": "Tous les ___ jours",
    "onDayInterval": "Me rappeler après ___",
    "onDayIntervalUnit": "Intervalle",
    "dateInterval": {
      "minutes": "Minutes",
      "hours": "Heures",
      "days": "Jours",
      "weeks": "Semaines",
      "months": "Mois"
    },
    "onDaysSkipped": "Tous les ___ jours la routine est incomplète",
    "onRoutineCompletions": "Toutes les ___ fois la routine est complétée",
    "onInterval": "Basé sur un intervalle",
    "selectRoutineToPrompt": "Sélectionner la routine à inviter",
    "selectAlertingLogic": "Sélectionner la logique d'alerte",
    "customLabelWhenAlertOccurs": "Étiquette personnalisée lorsque l'alerte se produit",
    "selectRoutine": "Sélectionner une routine",
    "reset": "Réinitialiser",
    "edit": {
      "alertName": "Nom de l'alerte",
      "asset(s)": "Actif(s)",
      "assets": "Actifs",
      "doNotAlert": "Ne pas alerter entre",
      "groups": "Groupes",
      "none": "Aucun",
      "promptRoutine": "<0>Sélectionner une routine</0><1>pour inviter avec cette alerte</1>",
      "promptRoutinePlaceholder": "aucune routine sélectionnée",
      "setFor": "Cette alerte est définie pour",
      "setOn": "Configurer l'alerte sur",
      "title": "Modifier l'alerte",
      "when": "Quand"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Oui",
        "secondaryButton": "Annuler",
        "title": "Êtes-vous sûr de vouloir supprimer {{alertName}} ?"
      },
      "delete": "Supprimer",
      "disableAlert": "Désactiver l'alerte",
      "enableAlert": "Activer l'alerte",
      "viewAlertActivities": "Voir les activités d'alerte"
    },
    "new": {
      "header": "Alertes > Créer une alerte"
    },
    "title": "Automatisation",
    "trigger": {
      "counter": {
        "ceiling": "Le compteur dépasse",
        "daysSinceCompleted": "La routine n'a pas été complétée depuis",
        "daysSinceCompleted-end": "Jours",
        "every": "Chaque",
        "every-end": "Jours",
        "floor": "Le compteur descend en dessous de",
        "onCompletionCount": "La routine a été complétée toutes les",
        "onCompletionCount-end": "Fois",
        "onInterval": "Le compteur atteint l'intervalle de"
      },
      "default": {
        "daysSinceCompleted": "La routine n'a pas été complétée depuis",
        "daysSinceCompleted-end": "Jours",
        "every": "Chaque",
        "every-end": "Jours",
        "onCompletionCount": "La routine a été complétée toutes les",
        "onCompletionCount-end": "Fois"
      }
    },
    "validation": {
      "alertTypeRequired": "Type d'alerte requis",
      "inputRequired": "Entrée requise",
      "invalidDate": "Date invalide",
      "startDateRequiredForDays": "Date de début requise pour le type d'alerte Jours",
      "routineIdRequiredForInterval": "ID de routine requis pour l'intervalle"
    },
    "setInterval": "Définir l'intervalle",
    "numberOfDays": "Nombre de jours",
    "numberOfTimes": "Nombre de fois"
  },
  "asset": {
    "advancedAssetInformation": "Informations avancées de l'actif",
    "customAlert": {
      "tagAlreadyAdded": "Cette étiquette est déjà ajoutée à cet actif.",
      "tryAnotherTag": "Cette étiquette est déjà utilisée et ne peut pas être sélectionnée, veuillez essayer une autre étiquette."
    },
    "delete": {
      "button": "Supprimer l'actif",
      "cancel": "Annuler",
      "confirm": "Supprimer",
      "title": "Êtes-vous sûr de vouloir supprimer cet actif ?"
    },
    "description": "Description",
    "descriptionPlaceholder": "Optionnel",
    "details": "Détails",
    "detailsPlaceHolder": "Optionnel",
    "editTitle": "Informations de l'actif",
    "groups": "Groupes",
    "groupsPlaceHolder": "(Optionnel) Sélectionner un ou plusieurs groupes",
    "groupsSearchPlaceHolder": "Rechercher un nom de groupe",
    "header": {
      "buttons": {
        "addNew": "Ajouter un rapport / une note",
        "routines": "Routines",
        "addSomething": "Ajouter quelque chose"
      },
      "recentActivity": "Activité récente",
      "activity": "Activité"
    },
    "information": "Informations de l'actif",
    "mediaLibrary": "Bibliothèque multimédia",
    "name": "Nom",
    "namePlaceholder": "Qu'est-ce que c'est ?",
    "newIssue": "Quelque chose de nouveau ?",
    "accessRequest": {
      "requestFull": "Demander l'accès complet",
      "requested": "Accès demandé",
      "modalTitle": "Demander l'accès complet",
      "modalSubtitle": "Laissez un message pour informer le propriétaire de l'espace de travail de la raison de votre demande d'accès.",
      "modalPlaceholder": "Message facultatif...",
      "modalSubmit": "Envoyer la demande"
    },
    "newTitle": "Configuration de l'actif",
    "tagCode": "Gripp ID",
    "qr": {
      "title": "Code QR du Gripp ID",
      "viewQrLabel": "Afficher le code QR pour {{tagCode}}",
      "tagAlt": "Étiquette Gripp {{tagCode}}"
    },
    "assetPicture": "Prendre une photo de l'actif",
    "newAsset": "Nouvel Actif",
    "assetName": "Nom",
    "newAdditionalMedia": "Photos",
    "secondaryDescription": "Description",
    "optionalSetting": "Paramètres optionnels",
    "hideReportAndNoteOptionsAnonymous": "Masquer les options Rapport et Note pour les visiteurs anonymes",
    "hideReportAndNote": "Rapport & Note",
    "hideForAnonymousVisitors": "Masquer pour les visiteurs anonymes",
    "files": {
      "title": "Fichiers",
      "noFiles": "Aucun fichier trouvé.",
      "addFilesLinks": "Ajouter des fichiers / liens",
      "addSheetTitle": "Ajouter",
      "addSheetSubtitle": "Fichier, média ou lien",
      "uploadFile": "Téléverser un fichier",
      "addLink": "Ajouter un lien",
      "save": "Enregistrer",
      "addFile": "Ajouter un fichier",
      "view": "Afficher {{count}} résultat",
      "view_plural": "Afficher {{count}} résultats",
      "camera": "Caméra",
      "file": "Fichier",
      "unableToPreview": "Impossible de prévisualiser"
    },
    "detail": {
      "edit": "Modifier",
      "delete": "Supprimer",
      "delete_asset": "Supprimer l'actif",
      "delete_warning": "Cette action ne peut pas être annulée.",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer le fichier {{fileName}} ?"
    },
    "productType": "Type de produit",
    "serialNumber": "Numéro de série",
    "addons": "Compléments ({{count}})",
    "addonsNoProduct": "Cet actif n'a pas de type de produit. Attribuez un produit pour activer la sélection des compléments.",
    "enterTagCode": "Entrer le code d'étiquette",
    "add": "Ajouter",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "tagCodePlaceholder": "Entrer le code d'étiquette",
    "lookingUpTag": "Recherche de l'étiquette...",
    "pinnedActivity": "Activité épinglée",
    "viewAll": "Tout voir"
  },
  "assets": {
    "filter": {
      "title": "Filtres",
      "search": "Rechercher",
      "recentSearches": "Recherches récentes",
      "apply": "Appliquer",
      "reset": "Réinitialiser",
      "viewResults": "Voir {{count}} résultats",
      "columnButton": "Colonnes",
      "columnSelection": "Colonnes",
      "columns": {
        "createdAt": "Créé le",
        "createdBy": "Créé par",
        "description": "Description",
        "serialNumber": "Numéro de série",
        "productName": "Nom du Produit",
        "groups": "Groupes",
        "groupNames": "Noms de Groupes",
        "lastAddress": "Emplacement",
        "lastScannedAt": "Dernier scan",
        "lastUpdated": "Dernière mise à jour",
        "name": "Nom (requis)",
        "notes": "# de notes",
        "alerts": "# d'alertes",
        "reports": "# de rapports actifs",
        "routines": "# de routines",
        "addons": "# de compléments",
        "tagCode": "Gripp ID",
        "workspaces": "Espace de travail"
      },
      "groups": "Groupes",
      "groupsButton": "Groupes",
      "default": "Par défaut",
      "searchPlaceholder": "Rechercher nom, description, produit, add-ons ou Gripp ID",
      "filterToggle": "Filtrage combiné :",
      "combinedGroups": "Filtrage combiné"
    },
    "groups": {
      "addAssetTo": "Ajouter 1 actif à :",
      "addAssetsTo": "Ajouter {{count}} actifs à :"
    },
    "list": {
      "createdAt": "Créé le",
      "createdDate": "Date de création",
      "createdTime": "Heure de création",
      "createdBy": "Créé par",
      "description": "Description",
      "serialNumber": "Numéro de série",
      "productName": "Nom du Produit",
      "groups": "Groupes",
      "groupNames": "Noms de Groupes",
      "lastAddress": "Emplacement",
      "lastScannedAt": "Dernier scan",
      "lastScannedDate": "Date du dernier scan",
      "lastScannedTime": "Heure du dernier scan",
      "lastUpdated": "Dernière mise à jour",
      "lastUpdatedDate": "Date de la dernière mise à jour",
      "lastUpdatedTime": "Heure de la dernière mise à jour",
      "name": "Nom",
      "notes": "Notes",
      "alerts": "Alertes",
      "reports": "Rapports actifs",
      "routines": "Routines",
      "addons": "Compléments",
      "tagCode": "Gripp ID",
      "workspaces": "Espace de travail"
    },
    "menu": {
      "title": "Actifs",
      "titleSingular": "Actif"
    },
    "textEmpty": "Aucun actif",
    "topBar": {
      "allAssets": "Tous les actifs",
      "assetSelected": "1 actif sélectionné",
      "assetsSelected": "{{count}} actifs sélectionnés",
      "results": "{{count}} résultats"
    },
    "change": "Changer",
    "routines": "Routines",
    "routineSearchPlaceholder": "Rechercher un nom de routine",
    "addonsSearchPlaceholder": "Rechercher un nom de complément"
  },
  "products": {
    "textEmpty": "Aucun produit",
    "list": {
      "name": "Nom"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Profil"
    }
  },
  "binaryCheck": {
    "button": "Mettre à jour",
    "instructions1": "Une nouvelle mise à jour est disponible !",
    "instructions2": "Gripp peut ne pas fonctionner jusqu'à ce moment."
  },
  "camera": {
    "Cancel": "Annuler",
    "grippInviteDetected": "Invitation Gripp détectée !",
    "grippTagDetected": "Étiquette Gripp détectée !",
    "noCameraAccess": "Aucun accès à la caméra",
    "notGrippInvite": "Ce n'est pas une invitation Gripp",
    "notGrippTagg": "Ce n'est pas une étiquette Gripp",
    "tryAgain": "Veuillez réessayer",
    "noPermissionModal": {
      "oopsMessage": "Oups ! Vous n'avez pas la permission d'accéder à cette étiquette Gripp. 🙈",
      "button": "Compris !",
      "errorMessage": "Si vous pensez que c'est une erreur, confirmez que vous êtes invité au bon espace de travail ou contactez le support Gripp."
    }
  },
  "changesSaved": "Modifications enregistrées",
  "common": {
    "back": "Retour",
    "cancel": "Annuler",
    "ok": "OK",
    "close": "Fermer",
    "create": "Créer",
    "download": "Télécharger",
    "reset": "Réinitialiser",
    "apply": "Appliquer",
    "save": "Enregistrer",
    "optional": "Optionnel",
    "value": "Valeur",
    "delete": "Supprimer",
    "confirmDelete": "Supprimer {{name}}",
    "deleteWarning": "Cette action ne peut pas être annulée.",
    "next": "Suivant",
    "remove": "Retirer",
    "typeMessage": "Tapez un message...",
    "message": "Message",
    "filter": "Filtre",
    "searchOrCreate": "Rechercher ou créer",
    "groupAssignments": "Affectations de groupes"
  },
  "customAlert": {
    "ok": "OK"
  },
  "deleteAccount": {
    "button": "Supprimer le compte",
    "cannotUndone": "Cette action ne peut pas être annulée.",
    "confirm": "Confirmer la suppression",
    "header": "Supprimer le compte",
    "reasonInput": "Veuillez nous faire savoir tout détail supplémentaire pour la suppression de votre compte (optionnel) :",
    "reasonInputNoOptional": "Veuillez nous faire savoir tout détail supplémentaire pour la suppression de votre compte :",
    "submitted": "Votre demande de suppression de compte a été soumise."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Appliquer",
      "reset": "Réinitialiser"
    }
  },
  "edit": "",
  "email": "E-mail",
  "features": {
    "title": "Fonctionnalités",
    "assignment": {
      "workspaces": "Espaces de travail",
      "accounts": "Comptes",
      "workspaceSearchPlaceholder": "Rechercher des espaces de travail...",
      "accountSearchPlaceholder": "Rechercher des comptes...",
      "noWorkspaces": "Aucun espace de travail trouvé",
      "noAccounts": "Aucun compte trouvé",
      "name": "Nom",
      "email": "Email",
      "phone": "Téléphone"
    }
  },
  "campaigns": {
    "menu": {
      "title": "Campagnes"
    },
    "page": {
      "title": "Campagnes"
    },
    "list": {
      "empty": "Aucune campagne trouvée",
      "addCampaign": "Créer une campagne"
    },
    "columns": {
      "name": "Nom",
      "status": "Statut",
      "responses": "Réponses",
      "groups": "Groupes",
      "products": "Produits",
      "serialNumber": "Numéro de série",
      "lastUpdated": "Dernière mise à jour",
      "createdAt": "Créé à"
    },
    "create": {
      "panelTitle": "Nouvelle campagne"
    },
    "responses": {
      "panelTitle": "Réponses"
    },
    "edit": {
      "panelTitle": "Modifier la campagne"
    }
  },
  "firstName": "Prénom",
  "forbidden": "Interdit",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Ajouter au groupe",
      "addtoNewGroup": "Ajouter à un nouveau groupe",
      "apply": "Appliquer",
      "clearGroups": "Effacer les groupes"
    },
    "searchGroups": "Rechercher des groupes",
    "noGroups": "Aucun groupe",
    "menu": {
      "title": "Groupes",
      "editGroup": "Modifier le groupe"
    },
    "create": {
      "label": "Créer un nouveau groupe",
      "validation": {
        "name_required": "Le nom du groupe est requis"
      },
      "create": "Créer",
      "placeholder": "ex. Groupe de tracteurs"
    },
    "list": {
      "name": "Nom du groupe",
      "people": "Personnes",
      "assets": "Actifs",
      "reports": "Rapports actifs",
      "routines": "Routines",
      "assetAlerts": "Alertes d'Actifs",
      "groupAlerts": "Alertes de Groupe"
    },
    "common": {
      "textEmpty": "Aucun groupe",
      "selectGroup": "Sélectionner des groupes",
      "searchGroup": "Rechercher des groupes",
      "createGroup": "Créer un groupe",
      "emptyStateMessage": "Créez un groupe en tapant directement dans la barre de recherche."
    },
    "filter": {
      "searchPlaceholder": "Rechercher des noms de groupes",
      "columnButton": "Colonnes",
      "columns": {
        "name": "Nom du groupe",
        "reports": "Rapports actifs",
        "assets": "Actifs",
        "people": "Personnes",
        "routines": "Routines",
        "assetAlerts": "Alertes d'Actifs",
        "groupAlerts": "Alertes de Groupe"
      },
      "columnSelection": "Colonnes"
    },
    "assignments": {
      "name": "Nom",
      "jobTitle": "Titre du poste",
      "accountType": "Type de compte",
      "assetSearchPlaceholder": "Rechercher nom d'actif, description ou nom de groupe",
      "accountSearchPlaceholder": "Rechercher nom de personne ou titre",
      "routineSearchPlaceholder": "Rechercher nom de routine",
      "groupSearchPlaceholder": "Rechercher noms de groupes",
      "addonsSearchPlaceholder": "Rechercher un nom de complément",
      "emptyAccountList": "Aucun compte",
      "assets": "Actifs",
      "groups": "Groupes",
      "people": "Personnes",
      "routines": "Routines"
    },
    "deleteGroup": {
      "deleteGroup": "Supprimer le groupe",
      "alertBody1": "Êtes-vous sûr de vouloir supprimer",
      "alertBody2": "Note : ",
      "alertBody3": "Cela ne supprimera aucun actif associé à ce ",
      "alertBody4": "groupe.",
      "delete": "Supprimer",
      "cancel": "Annuler",
      "toastTitle": "Effacé !",
      "toastMessage": "{{groupName}} a été supprimé."
    }
  },
  "help": {
    "menu": {
      "title": "Aide"
    }
  },
  "alertsManagement": {
    "menu": {
      "title": "Alertes",
      "editAlert": "Modifier l'alerte"
    },
    "filter": {
      "searchPlaceholder": "Rechercher des alertes...",
      "columnButton": "Colonnes",
      "columnSelection": "Sélection de colonnes",
      "columns": {
        "name": "Nom",
        "routineName": "Routine",
        "assetName": "Actif",
        "groupName": "Groupe",
        "productName": "Produit",
        "assetAlerts": "Alertes d'actifs",
        "lastAlertDate": "Dernière alerte",
        "nextAlertDate": "Prochaine alerte",
        "createdAt": "Créé",
        "status": "Statut"
      },
      "status": {
        "label": "Statut",
        "all": "Tous",
        "enabled": "Activé",
        "disabled": "Désactivé"
      }
    },
    "common": {
      "textEmpty": "Aucune alerte trouvée"
    },
    "list": {
      "name": "Nom",
      "routineName": "Routine",
      "assetName": "Actif",
      "groupName": "Groupe",
      "productName": "Produit",
      "assetAlerts": "Alertes d'actifs",
      "lastAlertDate": "Dernière alerte",
      "nextAlertDate": "Prochaine alerte",
      "createdAt": "Créé",
      "status": "Statut"
    },
    "deleteAlert": {
      "deleteAlert": "Supprimer l'alerte",
      "alertBody1": "Êtes-vous sûr de vouloir supprimer",
      "alertBody2": "Attention:",
      "alertBody3": " La suppression de cette alerte la supprimera définitivement ainsi que toutes les données associées.",
      "delete": "Supprimer",
      "cancel": "Annuler"
    },
    "actions": {
      "enable": "Activer",
      "disable": "Désactiver",
      "enableSuccess": "{count} alerte(s) activée(s) avec succès",
      "disableSuccess": "{count} alerte(s) désactivée(s) avec succès"
    }
  },
  "invitation": {
    "initial": {
      "heading": "Vous êtes invité à {{workspaceName}} !",
      "login": "Clé de connexion",
      "step1": "Étape 1",
      "step1Instructions": "Télécharger l'application Gripp",
      "step2": "Étape 2",
      "step2Instructions": "Utilisez cette clé pour vous connecter"
    },
    "invitePeople": {
      "copiedInvitationLink": "Lien d'invitation copié",
      "copyInviteLink": "Copier le lien d'invitation",
      "shareInviteLink": "Partager le lien d'invitation",
      "errorCopyingInvitationLink": "Une erreur s'est produite lors de la copie de l'URL d'invitation",
      "invitePeopleForm": "Inviter des personnes par e-mail",
      "invitePeopleQR": "Inviter des personnes via un code QR",
      "linkAllowsToJoinWorkplace": "Ce lien permet à quiconque de demander à rejoindre votre espace de travail.",
      "emailPlaceholder": "E-mail",
      "inviteViaEmailLabel": "Inviter par e-mail",
      "inviteSentSuccess": "Invitation envoyée avec succès",
      "inviteSentError": "Une erreur s'est produite lors de l'envoi de l'invitation",
      "placeholder": "E-mails",
      "send": "Envoyer",
      "submit": "Soumettre",
      "to": "À"
    },
    "pending": {
      "accepted": "Suivez le lien envoyé à votre e-mail pour vous connecter à votre compte Gripp.",
      "cancel": "Annuler",
      "join": "Rejoindre",
      "joining": "Vous rejoignez {{workspaceName}}",
      "title": "Créer un profil"
    },
    "qr": {
      "invitesYou": "vous invite à rejoindre",
      "showQr": "Afficher le QR pour inviter d'autres personnes"
    }
  },
  "issue": {
    "anonymous": {
      "addNote": "Ajouter une note",
      "createReport": "Créer un rapport",
      "getGrippCta": "Téléchargez Gripp pour voir l'activité, les fichiers et rejoindre la conversation !",
      "noteAdded": "Note bien prise !",
      "noteAddedDownloadGrippApp": "Téléchargez l'application Gripp pour une prise de notes encore plus facile !",
      "openAppStore": "Ouvrir l'App Store",
      "report": "Rapport",
      "reportAddedDownloadGrippApp": "Téléchargez l'application Gripp pour un rapport encore plus rapide !",
      "reported": "Problème signalé !",
      "routineCompleted": "Boom, mise à jour confirmée !",
      "routineCompletedDownloadGrippApp": "Téléchargez l'application Gripp pour une expérience optimale !",
      "dropRoutineTitle": "C'est fait.",
      "dropRoutineSubtitle": "Continuez dans Gripp pour scanner, signaler et consulter l'historique plus rapidement.",
      "dropReportTitle": "Restez informé.",
      "dropReportSubtitle": "Continuez dans Gripp pour voir les réponses, ajouter des notes et accéder à plus d'informations.",
      "dropCta": "Obtenir l'application",
      "dropCtaA11yLabel": "Obtenir l'application Gripp"
    },
    "common": {
      "addPicture": "Photos",
      "description": "Description",
      "followUp": "Suivi requis ?",
      "note": "Non, juste pour référence",
      "report": "Oui, suivi nécessaire",
      "addLabel": "Ajouter une étiquette",
      "labelSubtitle": "Pour une recherche et un filtrage plus faciles.",
      "selectLabel": "Sélectionner une étiquette",
      "searchLabel": "Rechercher une étiquette",
      "createLabel": "Créer une étiquette",
      "emptyStateMessage": "Créez une étiquette en tapant directement dans la barre de recherche.",
      "labelsApplied": "Étiquettes appliquées"
    },
    "delete": {
      "confirm": "Confirmer la suppression ?",
      "button": "Supprimer l'Issue",
      "warning": "Cette action est irréversible.",
      "cancel": "Annuler",
      "title": "Supprimer l'Activité"
    },
    "editModal": {
      "header": "Modifier",
      "save": "Enregistrer",
      "reviseSubmission": "Réviser la soumission",
      "pinDescription": "L'activité épinglée s'affiche dans les détails de l'actif"
    },
    "accessRequest": {
      "workspaceAccessRequest": "Demande d'accès à l'espace de travail : {{message}}",
      "requestingFullAccess": "Demande d'accès complet à l'espace de travail.",
      "approve": "Approuver",
      "deny": "Refuser",
      "approveA11y": "Approuver la demande d'accès",
      "denyA11y": "Refuser la demande d'accès"
    },
    "latestMessage": {
      "media": "[Média]"
    },
    "menu": {
      "delete": "Supprimer",
      "edit": "Modifier",
      "editRoutine": "Modifier la routine",
      "pinToAsset": "Épingler à l'actif",
      "print": "Imprimer",
      "reassign": "Réassigner",
      "reminder": "Rappel",
      "unpin": "Désépingler",
      "unpinToAsset": "Désépingler de l'actif"
    },
    "new": {
      "addIt": "Ajouter un rapport / une note",
      "editActivity": "Modifier l'activité",
      "labels": "Étiquettes",
      "optionalPlaceholder": "Optionnel",
      "placeholder": "Que voyez-vous ?",
      "reassign": "Réassigner",
      "reminder": "Rappel",
      "submit": "Soumettre",
      "title": "Titre",
      "type": "Type"
    },
    "quickReminder": {
      "header": "Définir un rappel",
      "subheader": "Pour programmer ce rapport à une date future."
    },
    "adjustCreationDate": {
      "header": "Ajuster la date de création"
    },
    "createdDate": {
      "header": "Date de création"
    },
    "types": {
      "attention": "Urgent",
      "urgent": "Urgent",
      "blocker": "En attente",
      "pending": "En attente",
      "done": "Résolu",
      "solved": "Résolu",
      "routines": "Routines",
      "note": "Note",
      "campaign": "Campagne"
    },
    "advancedSettings": "Paramètres avancés",
    "dateFormat": "JJ/MM/AAAA",
    "reminderFor": "Rappel pour :",
    "reassign": {
      "instructions": "À quel actif suivant voulez-vous réassigner ?",
      "placeholder": "Rechercher un nom d'actif",
      "saveLabel": "Enregistrer",
      "title": "Réassigner"
    },
    "topBar": {
      "allReplies": "réponses"
    },
    "reminder": {
      "notesOptional": "Notes (Optionnel)",
      "scheduled": "Rappel programmé"
    }
  },
  "job": "",
  "jobTitle": "Titre du poste",
  "lastName": "Nom de famille",
  "loading": "Chargement",
  "login": {
    "codeSentTo": "Un code de connexion a été envoyé à",
    "email": "E-mail",
    "error": {
      "invalidCredentials": "Identifiants invalides",
      "processError": "Une erreur s'est produite lors du traitement de votre demande"
    },
    "login": "Se connecter",
    "password": "Mot de passe",
    "resendCode": "Renvoyer le code",
    "tabs": {
      "new": {},
      "returning": {
        "title": "Je reviens"
      }
    },
    "tryAnotherMethod": "Essayer une autre méthode",
    "withEmail": "Continuer avec l'e-mail",
    "withPassword": "J'ai un mot de passe",
    "withPhone": "Continuer avec le téléphone",
    "continue": "Continuer",
    "skip": "Passer",
    "verify": "Vérifier",
    "didntReceiveCode": "Vous n'avez pas reçu de code ?",
    "welcome": "Bienvenue",
    "signUpToContinue": "Inscrivez-vous pour continuer",
    "orUsePrefix": "ou utiliser",
    "toggleEmail": "l'e-mail",
    "togglePhone": "le téléphone",
    "smsConfirmationMessage": "Nous vous enverrons un SMS pour confirmer votre numéro. Cela peut prendre quelques secondes.",
    "emailConfirmationMessage": "Nous vous enverrons un code de vérification pour confirmer votre e-mail. Cela peut prendre quelques secondes.",
    "verifyCodeSentTo": "Un code a été envoyé à",
    "aboutYourself": "Parlez-nous de vous !",
    "existingAccount": "Vous avez déjà un compte Gripp ?"
  },
  "logout": "Déconnexion",
  "errorBoundary": {
    "title": "Oups !",
    "message": "Une erreur inattendue s'est produite.",
    "tryAgain": "Réessayer"
  },
  "mentions": {
    "unknownUser": "Utilisateur inconnu",
    "youAreMentioned": "Vous êtes mentionné"
  },
  "media": {
    "validation": {
      "unsupported": "Ce fichier n'a pas pu être téléversé. Il est peut-être corrompu ou dans un format non pris en charge."
    }
  },
  "modalMessages": {
    "completed": "Terminé"
  },
  "or": "ou",
  "onboarding": {
    "shareInfo": "Partagez plus d'informations sur vous avec Gripp !",
    "industrial": "Domaine industriel",
    "source": "Comment avez-vous entendu parler de Gripp ?",
    "agriculture": "Agriculture"
  },
  "people": {
    "menu": {
      "people": "Personnes"
    }
  },
  "phone": "Numéro de téléphone",
  "plusMenu": {
    "add-asset": "Ajouter un actif",
    "invite": "Inviter",
    "no-tag": "Pas d'étiquette ?",
    "note": "Note",
    "report": "Rapport",
    "scan": "Scanner"
  },
  "preferences": {
    "language": {
      "languages": {
        "english": "Anglais",
        "spanish": "Espagnol",
        "russian": "Russe",
        "kazakh": "Kazakh",
        "afrikaans": "Afrikaans",
        "portuguese": "Portugais",
        "french": "Français"
      },
      "language": "Langue",
      "preferredLanguageTitle": "Langue Préférée"
    },
    "menu": {
      "title": "Paramètres"
    },
    "settings": {
      "notifications": "Notifications",
      "permissions": "Autorisations",
      "profile": "Profil",
      "title": "Paramètres",
      "workSpaces": "Espaces de travail",
      "workspace_settings": "Paramètres des espaces de travail"
    },
    "permissions": {
      "title": "Autorisations",
      "allow": "Autoriser",
      "location": {
        "label": "Services de localisation",
        "description": "Gripp utilise la localisation de votre téléphone pour mettre à jour l'emplacement de vos actifs lorsque vous les scannez. Au minimum, nous vous demandons d'autoriser la localisation pendant l'utilisation de l'application."
      },
      "camera": {
        "label": "Accès à la caméra",
        "description": "Prendre des notes et signaler des problèmes nécessite souvent de prendre une photo de ce que vous voyez, donc activer l'accès à la caméra est important pour vous tenir, vous et les autres, à jour."
      },
      "gallery": {
        "label": "Accès à la photothèque",
        "description": "Comme pour la caméra, vous avez parfois déjà des photos que vous souhaitez télécharger sur Gripp. Nous n'aurons accès qu'aux photos que vous choisissez au moment du téléchargement."
      },
      "pushNotifications": {
        "label": "Notifications push",
        "description": "Comme beaucoup d'applications, soyez averti lorsqu'une nouvelle alerte, un nouveau problème ou un nouveau rapport arrive. Vous ne voulez pas manquer quelque chose d'important."
      },
      "feature": {
        "scanner": "L'accès à la caméra est requis pour scanner les codes QR et ajouter des photos aux notes et rapports.",
        "gallery": "L'accès à la photothèque est requis pour télécharger des photos depuis votre bibliothèque vers les notes et rapports."
      }
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Notifications par libellés d'activité",
      "groupNotificationsTitle": "Notifications de groupe",
      "issueReplies": "Messages",
      "notificationTitle": "Notifications",
      "schedule": {
        "accept": "Accepter",
        "cancel": "Annuler",
        "endTime": "Heure de fin :",
        "everyDay": "Tous les jours",
        "notSet": "Non défini",
        "notificationSchedule": "Calendrier des notifications",
        "set": "Définir",
        "startTime": "Heure de début :",
        "weekDays": "Jours de la semaine"
      },
      "severities": {
        "blue": "Nouvelles routines",
        "purple": "Nouvelles notes",
        "red": "Nouveaux rapports"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Modifier le profil"
      },
      "impersonate": {
        "impersonate": "Personnifier",
        "unimpersonate": "Annuler la personnification"
      },
      "error": {
        "title": "Erreur lors de la mise à jour du profil",
        "generic": "Une erreur s'est produite lors de la mise à jour de votre profil. Veuillez réessayer.",
        "duplicatedPhone": "Ce numéro de téléphone est déjà associé à un autre compte."
      }
    },
    "admin": {
      "title": "Impersonnation",
      "workspace": "Espace de travail",
      "workspaceUsers": "Utilisateurs de l'espace de travail"
    }
  },
  "recent_activities": "Activités récentes",
  "reminders": {
    "deleteReminder": "Supprimer le rappel",
    "setNewReminder": "définir un nouveau rappel pour"
  },
  "requestRoutine": {
    "apply": "Appliquer",
    "header": "Routine",
    "instruction": "Veuillez soumettre votre idée de routine :",
    "placeHolder": "Que devrions-nous commencer à faire ?"
  },
  "routines": {
    "admin": {
      "create": "Enregistrer",
      "instructions": "Instructions",
      "issuePrefix": "Préfixe de problème",
      "reportOnException": "Rapport sur exception ?",
      "routineButtonText": "Bouton de routine",
      "title": "Titre",
      "type": "Type",
      "oneTimeOnly": "Une seule fois",
      "autoPrompt": "Demande automatique à l'ouverture de l'actif",
      "update": "Mettre à jour",
      "addMedia": "Ajouter un média",
      "image": "Image",
      "link": "Lien",
      "linkLabel": "Ajouter un lien",
      "linkUrl": "URL du lien",
      "linkUrlPlaceholder": "Entrer l'URL (ex. : https://example.com)",
      "invalidUrl": "URL invalide",
      "enableAutoPinning": "Activer la fixation automatique",
      "autoAddLabel": "Ajouter automatiquement une étiquette"
    },
    "assign": "Assigner des routines",
    "copyToWorkspace": {
      "save": "Copier",
      "title": "Copier vers l'espace de travail",
      "workspace": "Espace de travail"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Activer les décimales (Optionnel)",
        "tallyCounter": "Compteur de points",
        "uom": "Unité de mesure",
        "counterType": "Type de compteur"
      },
      "user": {
        "genericCounter": {
          "change": "Changer :",
          "initialValue": "Valeur initiale :",
          "newValue": "Nouvelle valeur :"
        },
        "tallyCounter": {
          "add": "+ Ajouter",
          "added": "Ajouté",
          "adding": "Ajout :",
          "instructions": "",
          "newValue": "Nouvelle valeur :",
          "oldValue": "Ancienne valeur :",
          "placeholder": "Entrer un nombre...",
          "remove": "- Retirer",
          "removed": "Retiré",
          "removing": "Retrait :"
        }
      },
      "counterTypes": {
        "SIMPLE": "Simple",
        "CUMULATIVE": "Cumulatif",
        "TALLY": "Points"
      }
    },
    "time": {
      "admin": {
        "time": "Type de temps",
        "labelStartTime": "Heure de début",
        "labelEndTime": "Heure de fin"
      },
      "timeTypes": {
        "START_END_TIMES": "Heures de début et de fin",
        "TIME_ONLY": "Heure uniquement",
        "DATE_ONLY": "Date uniquement"
      },
      "message": {
        "time": "Heure",
        "start": "Début",
        "end": "Fin",
        "date": "Date"
      }
    },
    "createNew": "Créer une routine",
    "edit": {
      "header": "Routines > Modifier la routine",
      "title": "Modifier la routine"
    },
    "editRoutines": {
      "editRoutinesButton": "Modifier les routines",
      "label": "Étiquette : ",
      "routineInWorkplace": "Toutes les routines disponibles dans votre espace de travail",
      "title": "Modifier",
      "saveSuccess": "Routines mises à jour avec succès",
      "saveError": "Échec de l'enregistrement des routines",
      "routineAdded": "La routine {{title}} a été ajoutée",
      "routineRemoved": "La routine {{title}} a été supprimée",
      "routineReordered": "Routines réorganisées avec succès"
    },
    "exceptions": {
      "addDetails": "Veuillez ajouter des détails supplémentaires ou des photos du problème :",
      "exceptionsNoticed": "{{count}} exception détectée",
      "exceptionsNoticed_plural": "{{count}} exceptions détectées",
      "reportCreated": "Un rapport a été créé",
      "viewRelatedReport": "Voir le rapport associé",
      "viewRelatedRoutine": "Voir la routine associée"
    },
    "header": {
      "title": "Routines",
      "view": "Voir",
      "viewAll": "Tout voir"
    },
    "menu": {
      "copyToWorkspace": "Copier vers l'espace de travail",
      "delete": {
        "cancel": "Annuler",
        "confirm": "Oui",
        "item": "Supprimer",
        "title": "Êtes-vous sûr de vouloir supprimer cette routine ?",
        "blockedTitle": "Routine en cours d'utilisation",
        "blockedGeneric": "Cette routine n'a pas pu être supprimée. Veuillez réessayer."
      },
      "download": "Télécharger",
      "editRoutine": "Modifier la routine",
      "export": "Exporter les données",
      "exporting": "Exportation..."
    },
    "message": {
      "messageTitle": "{{name}} a complété la routine :",
      "added": "ajouté",
      "removed": "retiré",
      "originalValue": "Valeur d'origine",
      "newValue": "Nouvelle valeur",
      "messageTitleUpdated": "{{name}} a effectué une mise à jour"
    },
    "modalCancel": {
      "primary": "Quitter sans enregistrer.",
      "secondary": "Annuler",
      "title": "Avant de revenir,"
    },
    "draftModal": {
      "continueDraft": "Continuer le brouillon.",
      "startNew": "Commencer une nouvelle routine.",
      "cancel": "Annuler",
      "messageNoDraft": "Un brouillon a été enregistré",
      "messageWithoutCreator": "Un brouillon a été enregistré le {{date}}",
      "messageWithCreator": "Un brouillon a été enregistré par : \n{{creator}} le {{date}}"
    },
    "new": {
      "chooseTypeButton": "Étape suivante : Choisir les options",
      "header": "Routines > Créer une routine",
      "title": "Créer une routine"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Ajouter une option",
        "options": "Options"
      }
    },
    "requestButton": "+ Demander une routine",
    "signature": {
      "clear": "Effacer",
      "done": "Terminé",
      "sign": "Signer",
      "signature": "Signature",
      "submit": "Soumettre"
    },
    "status": {
      "admin": {
        "addStatus": "Ajouter un statut",
        "statuses": "Statuts",
        "openEndedResponse": "Réponse ouverte",
        "otherStatus": "Autre _______"
      }
    },
    "submit": "Soumettre",
    "resubmit": "Resoumettre",
    "saveDraft": "Enregistrer comme brouillon",
    "types": {
      "COUNTER": "Compteur",
      "QUICK_CONFIRM": "Confirmation rapide",
      "STATUS": "Statut",
      "WORKFLOW": "Mini formulaire"
    },
    "update": "Mettre à jour",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Ajouter une question",
          "duplicateQuestion": "Dupliquer la question",
          "instructions": "Instructions",
          "page": "Page {{page}}",
          "questionType": "Type de question"
        },
        "question": {
          "addOption": "Ajouter une option",
          "exception": {
            "HasResponse": "A une réponse",
            "MissingResponse": "Réponse manquante",
            "Off": "Désactivé",
            "label": "Gestion des exceptions :"
          },
          "instructions": "Instructions",
          "multiline": "Multiligne",
          "options": "Options",
          "question": "Question {{question}}",
          "barcodeScanner": {
            "allowMultiple": "Autoriser plusieurs entrées",
            "includeQuantity": "Inclure le champ quantité"
          }
        },
        "routine": {
          "label": "Routine",
          "select": "Sélectionner une routine"
        }
      },
      "execution": {
        "optional": "Optionnel",
        "submit": "Soumettre",
        "barcodeScanner": {
          "addAnother": "Ajouter un autre",
          "placeholder": "Saisir ou scanner un code-barres",
          "placeholderManual": "Saisir un code-barres",
          "quantityPlaceholder": "Qté",
          "quantityLabel": "Qté : {{quantity}}",
          "remove": "Supprimer l'entrée",
          "scan": "Scanner le code-barres"
        },
        "location": {
          "placeholder": "Appuyez pour capturer la position",
          "captureLabel": "Capturer la position actuelle"
        }
      },
      "questionTypes": {
        "CHECKBOX": "Sélection multiple",
        "COUNTER": "Compteur",
        "MEDIA": "Média",
        "QUICK_CONFIRM": "Confirmation rapide",
        "RADIO": "Sélection unique",
        "ROUTINE": "Routine",
        "SIGNATURE": "Signature",
        "STATUS": "Statut",
        "TEXT": "Texte",
        "TIME": "Heure",
        "LABEL": "Étiquette",
        "BARCODE_SCANNER": "Scanner de codes-barres",
        "LOCATION": "Emplacement"
      }
    },
    "textEmpty": "Aucune routine",
    "addToGroups": "Ajouter aux groupes",
    "addToGroupsDescription": "Assigner {{count}} routines sélectionnées aux groupes",
    "list": {
      "name": "Nom",
      "type": "Type",
      "groups": "Groupes"
    }
  },
  "saveChanges": "Enregistrer les modifications",
  "unsavedChanges": {
    "title": "Modifications non enregistrées",
    "subtitle": "Voulez-vous enregistrer votre progression avant de continuer ?",
    "saveAndExit": "Enregistrer et quitter",
    "dontSave": "Ne pas enregistrer"
  },
  "signOut": "Se déconnecter",
  "support": {
    "genericDescription": "Parfois des problèmes surviennent, mais si vous voyez cette page à nouveau, veuillez nous le faire savoir pour que nous puissions corriger !",
    "sendEmail": "Ou envoyez-moi un e-mail à",
    "title": "Oups, nous avons fait une erreur"
  },
  "tags": {
    "assetName": "Nom de l'actif",
    "batches": {
      "title": "Commandes"
    },
    "status": "Statut",
    "tagCode": "Numéro d'étiquette",
    "title": "Étiquettes",
    "updatedAt": "Mis à jour le",
    "version": "Version"
  },
  "textEmptyList": "Aucune donnée",
  "topNav": {
    "activities": "Activité",
    "add": "Ajouter",
    "assetInfo": "Voir l'actif",
    "assets": "Actifs",
    "back": "Retour",
    "backButton": {
      "cancel": "Continuer l'édition",
      "confirmBack": "Il y a des modifications non enregistrées !",
      "ok": "Quitter sans enregistrer"
    },
    "cancel": "Annuler",
    "customAlert": {
      "cancel": "Annuler",
      "deleteAccount": "Êtes-vous sûr de vouloir supprimer votre compte ?",
      "exit": "Quitter sans enregistrer ?",
      "signOut": "Êtes-vous sûr de vouloir vous déconnecter ?",
      "yes": "Oui",
      "saveProgress": "Enregistrer pour plus tard."
    },
    "edit": "Modifier",
    "editAsset": "Informations de l'actif",
    "invite": "Inviter des personnes",
    "moreAssetInfo": "Plus d'informations sur l'actif",
    "moreWorkspaceInfo": "Plus d'informations sur l'espace de travail",
    "save": "Enregistrer",
    "myHistory": "Mon historique",
    "modify": "Modifier"
  },
  "translation": {
    "seeOriginal": "Voir l'original",
    "seeTranslation": "Voir la traduction"
  },
  "versionCheck": {
    "description": "Mises à jour disponibles ! Certaines fonctionnalités peuvent ne pas fonctionner jusqu'à ce que vous actualisiez le navigateur.",
    "refreshButton": "Actualiser"
  },
  "offline": {
    "banner": {
      "title": "Vous êtes hors ligne"
    }
  },
  "workspace": {
    "editTitle": "Informations de l'espace de travail",
    "titleSingular": "Espace de travail",
    "filter": {
      "searchPlaceholder": "Rechercher un nom",
      "columnButton": "Colonnes",
      "tierButton": "Abonnement",
      "columnSelection": "Colonnes",
      "tierSelection": "Abonnement",
      "typeSelection": "Type",
      "columns": {
        "name": "Nom",
        "owner": "Administrateur",
        "type": "Type",
        "subscriptionTierId": "Abonnement",
        "assetsCount": "Actifs",
        "routinesCount": "Routines",
        "alerts": "Alertes",
        "peopleCount": "Personnes",
        "activitiesCount": "Activités",
        "groupsCount": "Groupes",
        "createdAt": "Créé le",
        "createdDate": "Date de création",
        "createdTime": "Heure de création",
        "createdBy": "Créé par",
        "lastScanned": "Dernier scan",
        "lastScannedDate": "Date du dernier scan",
        "lastScannedTime": "Heure du dernier scan",
        "updatedAt": "Dernière mise à jour",
        "updatedDate": "Date de la dernière mise à jour",
        "updatedTime": "Heure de la dernière mise à jour",
        "lastActivity": "Dernière activité",
        "lastActivityDate": "Date de la dernière activité",
        "lastActivityTime": "Heure de la dernière activité"
      }
    },
    "types": {
      "PRODUCER": "Producteur",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Soumettre",
      "administratorEmail": "E-mail de l'administrateur",
      "administratorPhone": "Numéro de téléphone de l'administrateur",
      "administratorFirstName": "Prénom de l'administrateur",
      "administratorLastName": "Nom de famille de l'administrateur",
      "copyRoutines": "Copier les routines",
      "title": "Créer un espace de travail",
      "validation": {
        "admin_email_required": "L'e-mail de l'administrateur est requis",
        "admin_first_name_required": "Le prénom de l'administrateur est requis",
        "admin_last_name_required": "Le nom de famille de l'administrateur est requis",
        "name_required": "Le nom de l'espace de travail est requis",
        "valid_emil": "L'e-mail de l'administrateur doit être une adresse e-mail valide"
      },
      "type": "Type",
      "workspaceName": "Nom de l'espace de travail",
      "name": "Nom de l'espace de travail"
    },
    "createButton": "Créer un espace de travail",
    "menu": {
      "editWorkspace": "Modifier l'espace de travail",
      "duplicateWorkspace": "Dupliquer l'espace de travail"
    },
    "duplicate": {
      "title": "Dupliquer l'espace de travail",
      "sourceLabel": "Duplication depuis",
      "contentToCopy": "Contenu à copier",
      "activities": "Activités",
      "assets": "Actifs",
      "routines": "Routines",
      "people": "Personnes",
      "alerts": "Alertes",
      "groups": "Groupes",
      "duplicateButton": "Dupliquer l'espace de travail"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Supprimer l'espace de travail",
      "alertBody1": "Êtes-vous sûr de vouloir supprimer",
      "alertBody2": "Note : ",
      "alertBody3": "Cela ne supprimera aucun actif associé à cet ",
      "alertBody4": "espace de travail.",
      "delete": "Supprimer",
      "cancel": "Annuler"
    },
    "list": {
      "name": "Nom",
      "owner": "Administrateur",
      "type": "Type",
      "assetsCount": "Actifs",
      "routinesCount": "Routines",
      "alerts": "Alertes",
      "peopleCount": "Personnes",
      "activitiesCount": "Activités",
      "groupsCount": "Groupes",
      "createdAt": "Créé le",
      "createdDate": "Date de création",
      "createdTime": "Heure de création",
      "createdBy": "Créé par",
      "lastScanned": "Dernier scan",
      "lastScannedDate": "Date du dernier scan",
      "lastScannedTime": "Heure du dernier scan",
      "updatedAt": "Dernière mise à jour",
      "updatedDate": "Date de la dernière mise à jour",
      "updatedTime": "Heure de la dernière mise à jour",
      "lastActivity": "Dernière activité",
      "lastActivityDate": "Date de la dernière activité",
      "lastActivityTime": "Heure de la dernière activité"
    }
  },
  "permissions": {
    "backButton": "Retour",
    "continueButton": "Continuer",
    "enableInSettings": "Vous pouvez activer cette permission dans les paramètres système.",
    "openSetting": "Ouvrir les paramètres",
    "welcome": {
      "title": "Bienvenue sur Gripp !",
      "description1": "Pour utiliser Gripp, nous devons activer plusieurs permissions.",
      "description2": "Nous vous guiderons à travers chacune d'elles pour expliquer pourquoi nous en avons besoin.",
      "description3": "Tous les paramètres peuvent être ajustés via les paramètres de votre téléphone à tout moment."
    },
    "location": {
      "initial": {
        "title": "Accès à votre localisation, pour suivre vos actifs.",
        "description1": "Gripp utilise la localisation de votre téléphone pour mettre à jour la localisation de vos actifs lorsque vous les scannez.",
        "description2": "Au minimum, nous vous demandons d'autoriser la localisation lors de l'utilisation de l'application."
      },
      "denied": {
        "title": "Accès à la localisation, pour suivre vos actifs.",
        "description1": "La localisation aide à suivre vos actifs."
      },
      "button": "Continuer"
    },
    "camera": {
      "initial": {
        "title": "Accès à votre caméra, pour capturer, envoyer des messages et signaler.",
        "description1": "Prendre des notes et signaler des problèmes nécessitent souvent de prendre une photo de ce que vous voyez."
      },
      "denied": {
        "title": "Accès à la caméra, pour capturer, envoyer des messages et signaler.",
        "description1": "L'accès à la caméra vous permet de capturer et signaler."
      },
      "button": "Continuer"
    },
    "gallery": {
      "initial": {
        "title": "Accès à votre galerie photo, pour télécharger des images.",
        "description1": "Parfois vous avez déjà des images que vous souhaitez télécharger dans Gripp.",
        "description2": "Gripp n'aura accès qu'aux images que vous choisissez au moment du téléchargement."
      },
      "denied": {
        "title": "Accès à la galerie photo, pour télécharger des images.",
        "description1": "L'accès à la galerie vous permet de télécharger les images que vous choisissez."
      },
      "button": "Continuer"
    },
    "notification": {
      "initial": {
        "title": "Restez informé avec les notifications.",
        "description1": "Soyez notifié lorsqu'une nouvelle alerte, un problème ou un rapport arrive.",
        "description2": "Ce sont uniquement pour les notifications d'équipe et ne sont pas liées aux notifications marketing."
      },
      "denied": {
        "title": "Notifications, pour rester informé.",
        "description1": "Recevez les alertes, problèmes et rapports de l'équipe—pas de messages marketing."
      },
      "button": "Continuer"
    },
    "allSet": "Tout est prêt, commençons avec Gripp !"
  },
  "routine": {
    "list": {
      "name": "Nom",
      "type": "Type de routine",
      "groups": "Groupes",
      "routines": "Routines",
      "oldRoutines": "Anciennes routines",
      "asset": {
        "name": "Nom",
        "description": "Description",
        "groups": "Groupes"
      }
    },
    "filter": {
      "searchPlaceholder": "Rechercher un nom de routine",
      "columnButton": "Colonnes",
      "columnSelection": "Colonnes",
      "columns": {
        "name": "Nom",
        "type": "Type de routine",
        "assetsCount": "Actifs",
        "addonsCount": "Compléments",
        "allAssetsCount": "Tous les actifs",
        "submissionsCount": "Soumissions",
        "groups": "Groupes",
        "groupNames": "Noms de Groupes",
        "lastSubmitted": "Dernière soumission",
        "updatedAt": "Dernière modification",
        "createdAt": "Date de création",
        "workspace": "Espace de travail"
      }
    },
    "rowHeader": {
      "routineSelected": "1 routine sélectionnée",
      "routinesSelected": "{{count}} routines sélectionnées"
    },
    "permittedRoles": {
      "label": "Rôles Autorisés",
      "noRoles": "Aucun rôle disponible"
    }
  },
  "product": {
    "change": "Changer",
    "list": {
      "products": "Produits",
      "name": "Nom",
      "description": "Description",
      "assetsCount": "Actifs",
      "filesCount": "Fichiers",
      "addonsCount": "Compléments",
      "routines": "Routines",
      "alerts": "Alertes d'actifs",
      "productAlerts": "Alertes de produits",
      "createdAt": "Créé le",
      "updatedAt": "Dernière mise à jour"
    },
    "filter": {
      "searchPlaceholder": "Rechercher un nom de produit",
      "columnButton": "Colonnes",
      "columns": {
        "name": "Nom",
        "description": "Description",
        "assetsCount": "Actifs",
        "filesCount": "Fichiers",
        "addonsCount": "Compléments",
        "routines": "Routines",
        "alerts": "Alertes d'actifs",
        "productAlerts": "Alertes de produits",
        "createdAt": "Créé le",
        "updatedAt": "Dernière mise à jour"
      },
      "columnSelection": "Colonnes"
    },
    "create": {
      "label": "Créer un nouveau produit",
      "validation": {
        "name_required": "Le nom du produit est requis"
      },
      "cancel": "Annuler",
      "create": "Créer",
      "placeholder": "ex. Produit 1"
    },
    "delete": {
      "button": "Supprimer le produit",
      "cancel": "Annuler",
      "confirm": "Oui",
      "title": "Êtes-vous sûr de vouloir supprimer le produit {{productName}} ?"
    },
    "detail": {
      "addon_options": "Options de complément",
      "no_addon_options": "Il n'y a pas d'options de complément pour ce produit.",
      "add_more": "Ajouter plus",
      "description": "Description",
      "details": "Détails",
      "files": {
        "placeholder": "Des fichiers supplémentaires à télécharger ? (plaques de données, autocollants OEM, etc.)",
        "addFilesLinks": "Ajouter des fichiers / liens"
      },
      "save": "Enregistrer",
      "cancel": "Annuler",
      "profile": "Profil du produit",
      "assets": "Actifs",
      "routines": "Routines",
      "noAvailableRoutines": "Aucune routine disponible à ajouter",
      "edit": "Modifier",
      "delete": "Supprimer",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer le produit {{fileName}} ?"
    },
    "specifications": {
      "title": "Toutes les spécifications",
      "upload": "Télécharger les données",
      "download": "Télécharger",
      "add_more": "Ajouter plus",
      "label_placeholder": "Nom de la spécification",
      "value_placeholder": "Valeur",
      "delete_confirm": "Êtes-vous sûr de vouloir supprimer cette spécification ?",
      "upload_coming_soon": "La fonctionnalité de téléchargement CSV arrive bientôt",
      "download_coming_soon": "La fonctionnalité de téléchargement CSV arrive bientôt",
      "upload_success": "Spécifications téléchargées avec succès",
      "upload_error": "Échec du téléchargement des spécifications. Veuillez réessayer.",
      "download_error": "Échec du téléchargement des spécifications. Veuillez réessayer.",
      "download_title": "Télécharger les spécifications",
      "no_data_to_download": "Aucune spécification à télécharger",
      "sharing_not_available": "Le partage de fichiers n'est pas disponible sur cet appareil"
    },
    "assignments": {
      "assets": "Actifs",
      "routines": "Routines",
      "files": "Fichiers",
      "addons": "Compléments",
      "searchPlaceholder": "Rechercher un nom",
      "assetSearchPlaceholder": "Rechercher un nom d'actif",
      "routineSearchPlaceholder": "Rechercher un nom de routine",
      "fileSearchPlaceholder": "Rechercher un nom de fichier",
      "addonSearchPlaceholder": "Rechercher un nom de complément"
    }
  },
  "file": {
    "list": {
      "files": "Fichiers",
      "name": "Nom",
      "products": "Produits",
      "assets": "Actifs",
      "addons": "Compléments",
      "categories": "Catégories",
      "lastUpdated": "Dernière mise à jour",
      "createdAt": "Créé le"
    },
    "filter": {
      "searchPlaceholder": "Rechercher un nom de fichier",
      "columnButton": "Colonnes",
      "categories": "Catégories",
      "searchCategories": "Rechercher des catégories",
      "deleteCategory": "Supprimer la catégorie",
      "deleteCategoryMessage": "Êtes-vous sûr de vouloir supprimer \"{{categoryName}}\" ? Cela supprimera la catégorie de {{fileCount}} fichiers.",
      "columns": {
        "name": "Nom",
        "productsCount": "Produits",
        "assetsCount": "Actifs",
        "addonsCount": "Compléments",
        "categories": "Catégories",
        "updatedAt": "Dernière mise à jour",
        "createdAt": "Créé le"
      },
      "columnSelection": "Colonnes"
    },
    "assignments": {
      "productsSearchPlaceholder": "Rechercher un nom de produit",
      "addonsSearchPlaceholder": "Rechercher un nom de complément"
    },
    "create": {
      "label": "Ajouter un fichier",
      "linkLabel": "Ajouter un lien",
      "title": "Titre",
      "linkUrl": "URL du lien",
      "category": "Catégorie",
      "file": "Fichier (un seul fichier)",
      "link": "Lien (un seul lien)",
      "add": "Ajouter",
      "addLink": "Ajouter un lien",
      "titlePlaceholder": "Entrer le titre du fichier",
      "linkUrlPlaceholder": "Entrer l'URL (ex. : https://example.com)",
      "categoryPlaceholder": "Sélectionner des catégories",
      "categorySearchPlaceholder": "Rechercher des catégories",
      "createCategory": "Créer une catégorie",
      "enterCategoryNamePlaceholder": "Saisir le nom de la catégorie",
      "creatingCategory": "Création...",
      "selectCategory": "Sélectionner des catégories",
      "searchCategory": "Rechercher des catégories",
      "emptyStateMessage": "Créez une catégorie en tapant directement dans la barre de recherche.",
      "clickToUpload": "Cliquer pour télécharger le fichier",
      "linkPlaceholder": "Entrer l'URL (ex. : https://example.com)",
      "validation": {
        "title_required": "Le titre du fichier est requis",
        "category_required": "Au moins une catégorie est requise",
        "link_required": "L'URL du lien est requise",
        "link_invalid": "Veuillez entrer une URL valide"
      },
      "uploadError": "Échec du téléchargement du fichier. Veuillez réessayer.",
      "linkError": "Échec de la création du lien. Veuillez réessayer.",
      "placeholder": "Nom du fichier"
    },
    "dropdown": {
      "createFile": "Créer un fichier",
      "file": "Fichier",
      "link": "Lien"
    },
    "tabs": {
      "products": "Produits",
      "addons": "Compléments"
    },
    "deleteFile": {
      "deleteFile": "Supprimer le fichier",
      "alertBody1": "Êtes-vous sûr de vouloir supprimer",
      "delete": "Supprimer",
      "cancel": "Annuler"
    },
    "assets": {
      "title": "Actifs",
      "name": "Nom",
      "description": "Description",
      "lastScanned": "Dernier scan",
      "lastAddress": "Dernière adresse",
      "lastUpdated": "Dernière mise à jour",
      "noAssets": "Aucun actif trouvé"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Compléments",
      "name": "Nom",
      "product": "Produits",
      "asset": "Actifs",
      "media": "Fichiers",
      "routines": "Routines",
      "createdAt": "Créé le",
      "updatedAt": "Dernière mise à jour",
      "addon": "Complément"
    },
    "filter": {
      "searchPlaceholder": "Rechercher un nom de complément",
      "columnButton": "Colonnes",
      "columns": {
        "name": "Nom",
        "product": "Produits",
        "asset": "Actifs",
        "media": "Fichiers",
        "routines": "Routines",
        "createdAt": "Créé le",
        "updatedAt": "Dernière mise à jour"
      },
      "columnSelection": "Colonnes"
    },
    "create": {
      "label": "Créer un complément",
      "validation": {
        "name_required": "Le nom du complément est requis"
      },
      "cancel": "Annuler",
      "create": "Créer",
      "placeholder": "ex. Complément 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Rechercher un nom de produit",
      "mediaSearchPlaceholder": "Rechercher un nom de fichier",
      "routineSearchPlaceholder": "Rechercher un nom de routine",
      "success": "Produits assignés au complément avec succès",
      "error": "Vous devez fournir les ID des produits"
    },
    "files": {
      "title": "Fichiers",
      "name": "Nom",
      "type": "Type",
      "extension": "Extension",
      "textEmpty": "Aucun fichier trouvé",
      "addFilesLinks": "Ajouter des fichiers / liens",
      "save": "Enregistrer",
      "delete": "Supprimer",
      "list": {
        "name": "Nom",
        "categories": "Catégories"
      }
    },
    "textEmpty": "Appuyez sur '+ Créer un complément' pour ajouter votre premier complément.",
    "edit": {
      "label": "Modifier le complément",
      "save": "Enregistrer"
    },
    "deleteAddon": "Supprimer le complément"
  },
  "labels": {
    "confirmTextLine1": "Êtes-vous sûr de vouloir supprimer l'étiquette \"{{labelName}}\" ?",
    "confirmTextLine2": "Cela supprimera l'étiquette de {{activityCount}} activités existantes.",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "editLabels": "Modifier les étiquettes",
    "labels": "Étiquettes",
    "yes": "Oui"
  },
  "categories": {
    "confirmTextLine1": "Êtes-vous sûr de vouloir supprimer la catégorie \"{{categoryName}}\" ?",
    "confirmTextLine2": "Cela supprimera la catégorie de {{fileCount}} fichiers existants.",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "editCategories": "Modifier les catégories",
    "categories": "Catégories",
    "yes": "Oui"
  }
}
